<template>
  <k-page>
    <template v-slot:header>
      <profile-header/>
    </template>
    <k-container size="lg" class="pb-20">
      <k-back class="my-5"/>
      <auto-invest-strategy-form
          :availableInvestments="availableInvestments"
          :validation="validation"
          :settings="settings"
          :accounts="$root.$data.investorProfile.accounts"
          v-model="form"
          @change="checkAvailableInvestments"
          @save="saveAndInvest"
          @preview="previewNoteOfAcceptance"
      />
    </k-container>
  </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader';
import AutoInvestStrategyForm from "@product-common/components/autoinvest/AutoInvestStrategyForm";

export default {
  components: {
    ProfileHeader,
    AutoInvestStrategyForm
  },
  data() {
    return {
      form: {
        strategyUuid: null,
        strategyName: '',
        acceptTerms: false,
        params: {
          currencyCode: 'USD',
          maxInvestmentInOneBorrower: 1000.00,
          portfolioSize: 1000.00,
          industries: ['ALL'],
          productTypes: ['ALL'],
          countries: ['ALL'],
          loanOriginators: ['ALL'],
          minInterestRate: 6,
          maxInterestRate: 14,
          minRemainingLoanTerm: 5,
          maxRemainingLoanTerm: 24,
        }
      },
      validation: {
        fieldErrors: {}
      },
      availableInvestments: {
        borrowerCount: 1,
        amount: 1000
      },
      settings: {
        minInterestRate: 1,
        maxInterestRate: 100,
        minRemainingLoanTerm: 1,
        maxRemainingLoanTerm: 84,
        countries: [],
        industries: [],
        productTypes: [],
        loanOriginators: []
      },
      strategyUuid: null,
    }
  },
  created() {
    this.strategyUuid = this.$route.params.strategyUuid;
    this.form.strategyUuid = this.strategyUuid;
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    async refresh() {
      this.form.acceptTerms = false;
      this.settings = await this.$post('autoinvestment/strategy-settings');

      if (this.strategyUuid) {
        this.form = await this.$get(`autoinvestment/strategy/${this.strategyUuid}`);
      }
    },
    async previewNoteOfAcceptance() {
      this.$startLoading();
      try {
        const response = await this.$http.post('/api/investor/autoinvestment/strategy/note-of-acceptance-preview',
            this.form,
            {responseType: 'arraybuffer'});
        let blob = new Blob([response.data], {type: response.headers['content-type']});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['k-filename'];
        link.click();
      } finally {
        this.$finishLoading();
      }
    },
    async checkAvailableInvestments(form) {
      let data = await this.$post('autoinvestment/available-investments', form);
      this.availableInvestments = data.availableInvestments;
    },
    async saveAndInvest(form) {
      try {
        await this.$post('autoinvestment/strategy', form);
        this.$router.push({name: 'autoinvestment'});
        this.$message.success("You have successfully created the new strategy!");
      } catch (error) {
        this.$message.error("Failed to create strategy.");
        if (error.response && error.response.status === 400) {
          this.validation = error.response.data;
          this.$scrollToErrorField();
        }
      }
    },
  }
}
</script>


